import { useQuery } from "@tanstack/react-query";
import axios, { AxiosError, thrownResponse } from "axios_config";
import { IAuroraForcast } from "./interface";
import { formatingForcastData } from "tools/aurora";

export const useGetAuroraForcasts = () => {
  return useQuery<IAuroraForcast[] | undefined, AxiosError>(["get-aurora-forcasts"], async () => {
    const res = await axios.get(`/get-all-aurora-27-days`);
    if (res.status >= 200 && res.status < 300 && typeof res.data?.result) {
      if (typeof res.data.result === "undefined") {
        return [];
      } else {
        return formatingForcastData(res.data.result);
      }
    } else {
      thrownResponse(res);
    }
  });
};

export const useGetAlaskaVdo = () => {
  return useQuery<string, AxiosError>(["get-alaska-vdo"], async () => {
    const res = await axios.get(`/get-all-data-video-aurora`);
    if (res.status >= 200 && res.status < 300 && typeof res.data?.result) {
      return res.data?.result;
    } else {
      thrownResponse(res);
    }
  });
};
